import { wktToGeoJSON, geojsonToWKT } from '@terraformer/wkt';

import { objectCoordsToArray } from './coordsConverters';
import type {
  TRotationDeg, TRectangle, TPolygon, TEditData,
} from './types';

export type TDroiFormat = 'polygon' | 'rect';

export const convertEditDataToFormValues = (
  roiEditData: (TRectangle | TPolygon)[] | null,
  rotationDeg?: TRotationDeg,
  droi?: TPolygon,
  droiFormat: TDroiFormat = 'polygon',
): TEditData => {
  const roiRegion = roiEditData?.find((region) => region.type === 'roi');
  const droiList = roiEditData?.filter((region) => region.type === 'droi');

  // point3: 'rect' — только прямоугольные зоны, DROI проходит как есть (без WKT);
  // на данный момент поддерживается одно значение DROI — берём первую зону
  if (droiFormat === 'rect') {
    const droiRect = droiList?.[0] as TRectangle | undefined;

    return {
      roi: {
        x: roiRegion?.x,
        y: roiRegion?.y,
        width: roiRegion?.width,
        height: roiRegion?.height,
        mode: roiRegion?.mode,
      },
      droi: droiRect ? {
        x: droiRect.x,
        y: droiRect.y,
        width: droiRect.width,
        height: droiRect.height,
        mode: droiRect.mode,
      } : null,
      rotationDeg: rotationDeg as unknown as TRotationDeg,
    };
  }

  const getFigureType = () => {
    if (droi?.area) return wktToGeoJSON(droi?.area).type;
    if (droiList?.length) return droiList?.length > 1 ? 'MultiPolygon' : 'Polygon';
    return undefined;
  };

  const droiCoordinates = droiList?.map((droiRegion) => {
    if (droiRegion.figure === 'polygon') {
      // Для корректной записи WKT-формата требуется, чтобы координаты первой точки и последней были одинаковыми
      droiRegion.coords.push(droiRegion.coords[0]);
      const arrayCoords = objectCoordsToArray(droiRegion.coords);
      return getFigureType() === 'MultiPolygon' ? [arrayCoords] : arrayCoords;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return droiRegion.coords;
  });

  return {
    roi: {
      x: roiRegion?.x,
      y: roiRegion?.y,
      width: roiRegion?.width,
      height: roiRegion?.height,
      mode: roiRegion?.mode,
    },
    droi: droiCoordinates?.length ? {
      area: geojsonToWKT({
        coordinates: droiCoordinates,
        type: getFigureType(),
      }),
      mode: 'abs',
      form: 'wkt',
    } : null,
    rotationDeg: rotationDeg as unknown as TRotationDeg,
  };
};
